"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.booleanContentFragment = void 0;
exports.booleanContentFragment = `
fragment booleanContent on BooleanContent {
  value
}
`;
//# sourceMappingURL=boolean-content.js.map